import React from "react";
import { Wifi, Smartphone, Printer } from "lucide-react";
import { Card, Input, Toggle, Textarea } from "./FormComponents";

export const Step7 = ({ data, updateData, isLight }) => {
  const handleChange = (field, value) => {
    updateData("wifiTech", { ...data, [field]: value });
  };

  const handleNestedChange = (parent, field, value) => {
    updateData("wifiTech", {
      ...data,
      [parent]: {
        ...data[parent],
        [field]: value
      }
    });
  };

  return (
    <div className="flex flex-col gap-8">
      <Card title="WiFi Credentials" icon={Wifi} subtitle="Internet credentials and connectivity details." isLight={isLight}>
        <Toggle 
          label="Is Wi-Fi available at the property?" 
          value={data.available}
          isLight={isLight}
          onChange={(val) => {
            const updates = { available: val };
            if (!val) {
              updates.ssid = "";
              updates.password = "";
              updates.isRouterAccessible = false;
              updates.routerLocation = "";
              updates.coverage = "";
            }
            updateData("wifiTech", { ...data, ...updates });
          }}
          plain
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input 
              label="Network Name (SSID)" required placeholder="Kypser_Guest_WiFi" 
              value={data.ssid}
              isLight={isLight}
              onChange={(e) => handleChange("ssid", e.target.value)}
            />
            <Input 
              label="Password" required placeholder="guest2024" 
              value={data.password}
              isLight={isLight}
              onChange={(e) => handleChange("password", e.target.value)}
            />
            <div className="md:col-span-2 space-y-6">
              <Toggle 
                label="Is the router accessible to guests?" 
                value={data.isRouterAccessible}
                isLight={isLight}
                onChange={(val) => {
                  const updates = { isRouterAccessible: val };
                  if (!val) updates.routerLocation = "";
                  updateData("wifiTech", { ...data, ...updates });
                }}
              >
                <Input 
                  label="Where is the router?" placeholder="On the shelf next to the TV" required={data.isRouterAccessible}
                  value={data.routerLocation}
                  isLight={isLight}
                  onChange={(e) => handleChange("routerLocation", e.target.value)}
                />
              </Toggle>
              <Input 
                label="Coverage notes" placeholder="High-speed internet connection up to 500 Mbps" 
                value={data.coverage}
                isLight={isLight}
                onChange={(e) => handleChange("coverage", e.target.value)}
              />
            </div>
          </div>
        </Toggle>
      </Card>

      <Card title="Other Devices" icon={Smartphone} isLight={isLight}>
        <div className="flex flex-col gap-8">
          <Toggle 
            label="Smart home devices available?" 
            value={data.smartHome.available}
            isLight={isLight}
            onChange={(val) => {
              const updates = { available: val };
              if (!val) updates.description = "";
              updateData("wifiTech", {
                ...data,
                smartHome: { ...data.smartHome, ...updates }
              });
            }}
          >
            <Textarea 
              label="Which devices are available and how do guests use them?" placeholder="Alexa for music and lights. Say 'Alexa, turn off living room lights'." required={data.smartHome.available}
              value={data.smartHome.description}
              isLight={isLight}
              onChange={(e) => handleNestedChange("smartHome", "description", e.target.value)}
            />
          </Toggle>

          <Toggle 
            label="Printer available?" 
            value={data.printer.available}
            isLight={isLight}
            onChange={(val) => {
              const updates = { available: val };
              if (!val) {
                updates.location = "";
                updates.instructions = "";
              }
              updateData("wifiTech", {
                ...data,
                printer: { ...data.printer, ...updates }
              });
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Input 
                label="Location" placeholder="In the office desk drawer" required={data.printer.available}
                value={data.printer.location}
                isLight={isLight}
                onChange={(e) => handleNestedChange("printer", "location", e.target.value)}
              />
              <div className="md:col-span-2">
                <Textarea 
                  label="Instructions" placeholder="Connect via USB or WiFi using the code on the printer." 
                  value={data.printer.instructions}
                  isLight={isLight}
                  onChange={(e) => handleNestedChange("printer", "instructions", e.target.value)}
                />
              </div>
            </div>
          </Toggle>
        </div>
      </Card>
    </div>
  );
};
